import { EditableColumnType } from '@aon/aon-tws-common-ui/build/lib/components/EditableTable';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import ContentConstants from '../../../../contentConstants';
import { EditState, ITranslationEditItem } from '../../../../models';
import { setOpenedModalPopupName } from '../../../../store/SurveyContentItemsSlice';
import { TranslationHelper } from '../../../../utilities/TranslationHelper';
import { AddTranslationsButton } from '../../../translations/AddTranslationsButton';
import { TranslationEditorModal } from '../../../translations/TranslationEditorModal';

interface ITranslationEditorWrapperProps {
	property: 'Title' | 'Intro' | 'Instructions';
	propertyDisplayName: string;
	supportedLanguages: string[];
	defaultTranslation: ITranslationEditItem;
	translations: ITranslationEditItem[];
	enableHtmlEditor: boolean;
	inputType: EditableColumnType;
	disabled: boolean;
	onChange: (payload: Pick<ITranslationEditItem, 'cultureCode' | 'textValue'>) => void;
}

export const TranslationEditorWrapper = ({
	property,
	propertyDisplayName,
	supportedLanguages,
	defaultTranslation,
	translations,
	enableHtmlEditor,
	inputType,
	disabled,
	onChange,
}: ITranslationEditorWrapperProps) => {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const dispatch = useDispatch();
	const numberOfSupportedCultures = TranslationHelper.getCountOfSupportedCultures(defaultTranslation.language, supportedLanguages);
	useEffect(() => {
		if (isModalOpen) {
			dispatch(setOpenedModalPopupName(property));
		}
	}, [isModalOpen, dispatch, property]);

	if (numberOfSupportedCultures <= 0) {
		return null;
	}

	const headerTitle = `${propertyDisplayName} Translations`;
	const editableTranslations = TranslationHelper.getEditableTranslations(translations, defaultTranslation.cultureCode);
	const numberOfTranslations = TranslationHelper.getCountOfTranslations(editableTranslations);

	const saveTranslationsHandler = (items: ITranslationEditItem[]) => {
		for (const item of items) {
			if (item.editState === EditState.None) {
				continue;
			}

			const { cultureCode, textValue } = item;
			onChange({ cultureCode, textValue });
		}

		setIsModalOpen(false);
	};

	return (
		<>
			<AddTranslationsButton
				loading={false}
				disabled={disabled}
				onClick={() => setIsModalOpen(true)}
				numberOfSupportedLanguages={numberOfSupportedCultures}
				numberOfTranslations={numberOfTranslations}
			/>
			<TranslationEditorModal
				inputType={inputType}
				isOpen={isModalOpen}
				enableHtmlEditor={enableHtmlEditor}
				property={property}
				propertyDisplayName={propertyDisplayName}
				headerTitle={headerTitle}
				defaultTranslation={defaultTranslation}
				translations={editableTranslations}
				lastSavedTranslations={editableTranslations}
				primaryButtonText={ContentConstants.BUTTONS_UPDATE}
				saveTranslations={saveTranslationsHandler}
				onClose={() => setIsModalOpen(false)}
			/>
		</>
	);
};
